// Components
import { StyledItem, StyledLink, StyledSidebar, StyledSidebarList } from './SettingsSidebarStyles';

type TSettingsSidebarProps = {
  items: Array<{
    key: string;
    label: string;
    icon?: React.ReactNode;
  }>;
  activeKey: string;
  onChange?: (key: string) => void;
};

const SettingsSidebar = ({ items, activeKey, onChange }: TSettingsSidebarProps) => (
  <StyledSidebar>
    <StyledSidebarList>
      {items.map((item) => (
        <StyledItem key={item.key} $active={item.key === activeKey} onClick={() => onChange?.(item.key)}>
          <StyledLink>
            {item.icon}
            {item.label}
          </StyledLink>
        </StyledItem>
      ))}
    </StyledSidebarList>
  </StyledSidebar>
);

export default SettingsSidebar;
